import React, { useState, useEffect } from "react";
import MiniDrawer from "../../Component/newNavBarCM/newNavBar";
import { Box, CircularProgress, Grid } from "@mui/material";
import CmSearchSuggestionsQAPair from "../../Component/CmSearchSuggestionQAPair/CmSearchSuggestionsQAPair";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Home_PAGE_URL } from "../../Router/routerUrl";
import SearchSuggestionsQAPairInfo from "../../Component/SearchSuggestionQAPairInfo/SearchSuggestionQAPairInfo";
import { Actions } from "../../Action";
import { bindActionCreators } from "redux";
import CloseIcon from '@mui/icons-material/Close';
import SearchSuggestionsQAPairInfo2 from "../../Component/SearchSuggestionQAPairInfo/SearchSuggestionQAPairInfo2";
import VizHeader from "../../Component/VizHeader/VizHeader";
import GenAiAnswerComponent from "../../Component/GenAiAnswerComponent/GenAiAnswerComponent";
import { Collapse,Space,Tabs } from 'antd';
import VizParagraph from "../../Component/VizParagraph/VizParagraph";
import Layout from '../../NewComponent/LayoutCM/Layout';

export default function SearchSuggestionDetailPage() {
	const searchSuggestionsReducer = useSelector((state) => state.searchSuggestionsCM);
	const dispatch = useDispatch();
	const { resetRatingsData, getRatingsDataInSearchSuggestions, updateSearchData2, checkIfComingBackSearchSuggestions } = bindActionCreators(Actions, dispatch);
	const navigate = useNavigate();
	const currentPath = useLocation();


	const onClickCancel = () => {
		console.log()
		checkIfComingBackSearchSuggestions(true)
		navigate(-1)
		setTimeout(() => {
			checkIfComingBackSearchSuggestions(false)
		}, 200)
	}

	const routePage = () => {
		navigate(`${Home_PAGE_URL}suggestions`)
	}

	const onChange = (key) => {
		// console.log(key,'check key');
	  };

	  const text = `
	 Sample text
	`;

	const items2 = [
		{
		  key: '1',
		  label: 'Country',
		  children: 'Content of Tab Pane 1',
		},
		{
		  key: '2',
		  label: 'Region',
		  children: 'Content of Tab Pane 2',
		},
		{
		  key: '3',
		  label: 'Global',
		  children: 'Content of Tab Pane 3',
		},
	  ];

	const items = [
		{
			key: '1',
			label: <>
				<div style={{textTransform:'none'}}>
				<VizHeader type={4} isBold={true}>Re-routing Interval</VizHeader>
				</div>
				<div style={{color:'#686868'}}>
				<VizParagraph type={3}>Maximum amount of time for an Expert to answer a question before it gets routed to a different Expert</VizParagraph>
				</div>
			</>,
			children: <><span>Time-out Period</span><Tabs defaultActiveKey="1" items={items2} onChange={onChange} /></>,
		},
		{
		  key: '2',
		  label: 'This is panel header with no arrow icon',
		  children: <p>{text}</p>,
		},
	  ];

	  const onChange2 = (key) => {
		console.log(key);
	  };

	return (
		<>
			<Layout>
				<Box ></Box>
				{
					searchSuggestionsReducer.isLoading &&
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<CircularProgress />
					</div>
				}
				{
					searchSuggestionsReducer.isLoading === false &&
					<>
					<Grid container paddingTop={4} sx={{ width: '95%', marginLeft: 'auto', marginRight: 'auto' }}>
						<div style={{ justifyContent: 'space-between', display: 'flex', alignItems: 'center', width: '100%' }}>
							<div style={{
								justifyContent: 'center',
								display: 'flex', width: '100%'
							}}>
								<h3 style={{ marginBottom: 0 }}>
									<VizHeader type={4}>Record Details
									</VizHeader>
								</h3>
							</div>
							<div>
								<CloseIcon onClick={() => onClickCancel()} sx={{ fontSize: '36px', cursor: 'pointer' }} />
							</div>
						</div>
						{
							searchSuggestionsReducer.isLoading === false &&
							(searchSuggestionsReducer.searchSuggestionDetails.length > 0 || searchSuggestionsReducer.searchSuggestionDetails.length === 0)
							&& <SearchSuggestionsQAPairInfo tags={searchSuggestionsReducer.tags} postedDate={searchSuggestionsReducer.postedDate} seekerName={searchSuggestionsReducer.seekerName} userType={searchSuggestionsReducer.userType} data={searchSuggestionsReducer.questionText} />
							// && <SearchSuggestionsQAPairInfo2 tags = {searchSuggestionsReducer.tags} postedDate={searchSuggestionsReducer.postedDate} seekerName={searchSuggestionsReducer.seekerName}  userType={searchSuggestionsReducer.userType} data={searchSuggestionsReducer.questionText} />
						}
						{/* GenAI Answer Component code starts here */}
						{ searchSuggestionsReducer.genAISummary !== undefined && searchSuggestionsReducer.genAISummary!==''&& <GenAiAnswerComponent data={searchSuggestionsReducer?.genAISummary} />}
						{/* GenAI Answer Component code ends here */}
						{
							searchSuggestionsReducer.isLoading === false &&
							searchSuggestionsReducer.searchSuggestionDetails.length > 0 &&
							searchSuggestionsReducer.searchSuggestionDetails.map((data, ind) => {
								return < CmSearchSuggestionsQAPair data={data} index={ind} key={ind} />
							})
						}
						{/* {
							searchSuggestionsReducer.isLoading === false && searchSuggestionsReducer.searchSuggestionDetails.length === 0 
								&& 
								routePage()
						} */}
						{
							searchSuggestionsReducer.isLoading === false && 
							searchSuggestionsReducer.searchSuggestionDetails.length ===0 
							&&
							searchSuggestionsReducer.postedDate === 0 
							&& 
							searchSuggestionsReducer.seekerName === ''
							&&
							searchSuggestionsReducer.questionText === ''
							&& 
							routePage()
						}
							{/* <Space direction="vertical" style={{width:'100%'}}>
					<Collapse defaultActiveKey={['1']} onChange={onChange} items={items} expandIconPosition={'end'} />
					</Space> */}
					</Grid>
					</>
				}
			</Layout>
		</>
	)
}